import { includes } from "lodash";
import httpRequest from "./httpRequest";
import { Http } from "@material-ui/icons";
import {
  FETCH_EMPLOYEES,
  FETCH_CURRENT_USER,
  FETCH_DESIGNATIONS,
  FETCH_SKILLS,
  FETCH_PROJECTS,
  FETCH_SUB_PROJECTS,
  FETCH_MODULES,
  FETCH_LOCATIONS,
  FETCH_WORKTYPES,
  FETCH_ENTITIES,
  FETCH_EMPLOYEE_PERSONAL,
  FETCH_EMPLOYEE_PROFESSIONAL,
  UPDATE_EMPLOYEE_PROFESSIONAL,
  UPDATE_USER_PROFILE,
  DELETE_EMPLOYEE_PROJECT,
  ADD_EMPLOYEE_LEAD,
  REMOVE_EMPLOYEE_LEAD,
} from "./apiLists";

class Employeeservice {
  fetchEmployees = async (enitityid: string, user_type_id?: string) => {
    const url = `${httpRequest.devadminurl}${FETCH_EMPLOYEES}`;
    console.log("url", url);
    const data = await httpRequest.get(url, {
      params: {
        entity_id: enitityid,
        ...(user_type_id && { user_type_id }),
      },
    });

    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };

  fetch_employees = async (reqBody: any) => {
    const url = `${httpRequest.devadminurl}${FETCH_EMPLOYEES}`;
    console.log("url", url);
    const data = await httpRequest.post(url, reqBody);

    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };

  fetchDesignations = async (entityid: string, userID: string) => {
    const formdata = new FormData();
    formdata.append("app_id", "aso");
    formdata.append("entity_id", entityid);

    if (userID) {
      formdata.append("user_id", userID);
    }

    const url = `${httpRequest.signupurl}${FETCH_DESIGNATIONS}`;

    const data = await httpRequest.post(url, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    console.log("data.status", data.status);
    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };

  fetchEntities = async () => {
    const formdata = new FormData();
    formdata.append("app_id", "aso");

    const url = `${httpRequest.signupurl}${FETCH_ENTITIES}`;
    console.log("url", url);
    const data = await httpRequest.post(url, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    console.log("data.status", data.status);
    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };

  fetchLocations = async (entity_id: string) => {
    const url = `${httpRequest.devadminurl}${FETCH_LOCATIONS}`;
    const data = await httpRequest.get(url, {
      params: {
        entity_id,
      },
    });

    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };

  fetchProjects = async (entity_id: string) => {
    const url = `${httpRequest.devadminurl}${FETCH_PROJECTS}`;
    const data = await httpRequest.get(url, {
      params: {
        entity_id,
      },
    });

    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };

  fetchSubProjects = async (project_id: string | number) => {
    const url = `${httpRequest.devadminurl}${FETCH_SUB_PROJECTS}`;
    const data = await httpRequest.get(url, {
      params: {
        project_id,
      },
    });

    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };

  fetch_projects = async (entity_id: string, team_id: number) => {
    const url = `${httpRequest.devadminurl}${FETCH_PROJECTS}`;
    const data = await httpRequest.get(url, {
      params: {
        entity_id,
        team_id,
      },
    });

    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };

  fetch_sub_projects = async (
    project_id: string | number,
    sub_team_id: number
  ) => {
    const url = `${httpRequest.devadminurl}${FETCH_SUB_PROJECTS}`;
    const data = await httpRequest.get(url, {
      params: {
        project_id,
        sub_team_id,
      },
    });

    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };

  fetchEmployeeProfessionalDetails = async (employee_id: string) => {
    const url = `${httpRequest.devadminurl}${FETCH_EMPLOYEE_PROFESSIONAL}`;
    const data = await httpRequest.get(url, {
      params: {
        employee_id,
      },
    });

    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };

  fetchEmployeePersonalDetails = async (employee_id: string) => {
    try {
      const url = `${httpRequest.devadminurl}${FETCH_EMPLOYEE_PERSONAL}`;
      const data = await httpRequest.get(url, {
        params: {
          employee_id,
        },
      });

      if (data.status === 200) {
        return {
          ...data.data,
        };
      }
      return { error: "Error" };
    } catch (e: any) {
      return { error: "Error" };
    }
  };

  fetchSkills = async () => {
    const url = `${httpRequest.devadminurl}${FETCH_SKILLS}`;
    const data = await httpRequest.get(url);

    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };

  fetchWorkTypes = async () => {
    const url = `${httpRequest.devadminurl}${FETCH_WORKTYPES}`;
    const data = await httpRequest.get(url);

    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };

  fetchmodules = async () => {
    const url = `${httpRequest.devadminurl}${FETCH_MODULES}`;
    const data = await httpRequest.get(url);
    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };

  updateEmployeeProfessionalDetails = async (reqpayload: any) => {
    const url = `${httpRequest.devadminurl}${UPDATE_EMPLOYEE_PROFESSIONAL}`;
    const data = await httpRequest.post(url, reqpayload);

    if (data) {
      return {
        ...data.data,
        status: data.status,
      };
    }
    return {};
  };

  add_employee_leads = async (leadsList: any[]) => {
    try {
      let formdata = JSON.stringify(leadsList);

      const url = `${httpRequest.devadminurl}${ADD_EMPLOYEE_LEAD}`;
      const token = window.localStorage.getItem("auth_token");

      const data = await httpRequest.post(url, formdata, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (data) {
        return {
          ...data.data,
          status: data.status,
        };
      }
      return {};
    } catch (error) {
      return {};
    }
  };

  remove_employee_lead = async (
    employee_id: string,
    lead_id: string,
    is_nominal: boolean
  ) => {
    try {
      const formdata = new FormData();
      formdata.append("employee_id", employee_id);
      formdata.append("lead_id", lead_id);
      formdata.append("is_nominal", `${is_nominal}`);

      const url = `${httpRequest.devadminurl}${REMOVE_EMPLOYEE_LEAD}`;
      const data = await httpRequest.post(url, formdata);

      if (data) {
        return {
          ...data.data,
          status: data.status,
        };
      }
      return {};
    } catch (error) {
      return {};
    }
  };

  updateEmployeePersonalDetails = async (reqpayload: any) => {
    const url = `${httpRequest.devadminurl}${UPDATE_USER_PROFILE}`;
    const data = await httpRequest.post(url, {
      employee_data: { ...reqpayload },
      app_id: "aso",
    });

    if (data) {
      return {
        ...data.data,
        status: data.status,
      };
    }
  };

  delete_project = async (id: number) => {
    const url = `${httpRequest.devadminurl}${DELETE_EMPLOYEE_PROJECT}`;
    const data = await httpRequest.delete(url, {
      params: {
        id,
      },
    });

    if (data.status === 200) {
      return {
        ...data.data,
      };
    }
    return {};
  };
}

const employeeService = new Employeeservice();

export default employeeService;
